/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import IFabricantes from './entidades/fabricantes';
import IFiltrosFabricantes from './entidades/filtrosFabricantes';

export default class ModeloFabricantes {
    public consultarFabricantes() {
        return manejadorRest<IRespuesta<IFabricantes>>(() => negocioConfiguracion.get('Fabricantes/ConsultarListaFabricantes'));
    }
    public crearFabricantes(fabricantes: IFabricantes) {
        return manejadorRest<IRespuesta<IFabricantes>>(() =>
            negocioConfiguracion.post('Fabricantes/GuardarFabricantes', fabricantes)
        );
    }
    public editarFabricantes(fabricantes: IFabricantes) {
        return manejadorRest<IRespuesta<IFabricantes>>(() => negocioConfiguracion.put('Fabricantes/EditarFabricantes', fabricantes));
    }
    public eliminarFabricantes(fabricantes: IFabricantes) {
        return manejadorRest<IRespuesta<IFabricantes>>(() =>
            negocioConfiguracion.delete('Fabricantes/EliminarFabricantes', fabricantes)
        );
    }
    public consultarListaFabricantesPorFiltro(filtrosFabricantes: IFiltrosFabricantes) {
        return manejadorRest<IRespuesta<IFabricantes>>(
            () => negocioConfiguracion.post('Fabricantes/ConsultarListaFabricantesPorFiltro', filtrosFabricantes),
            true
        );
    }
}
